<input
  #fileInput
  (change)="fileChangeEvent($event)"
  accept="{{ acceptTypes }}"
  appNoLeadingSpace
  class="image-file-uploader"
  type="file"
  [multiple]="multipleUpload"
/>

<div class="img-cropper-dialog">
  <p-dialog
    [(visible)]="displayImageCropper"
    [baseZIndex]="10000"
    [maximizable]="false"
    [minY]="70"
    [modal]="true"
    [style]="{ width: dialogWidth, minWidth: '300px', maxHeight: '90vh' }"
    appendTo="body"
    [blockScroll]="false"
    styleClass="mi-mob-fullscreen-dialog img-cropper-dialog-panel">
    <app-image-cropper-dialog
      [(visible)]="displayImageCropper"
      [dialogWidth]="dialogWidth"
      [isSwitcherCropperActive]="isSwitcherCropperActive"
      [isRoundCropper]="isRoundCropper"
      [aspectRatio]="aspectRatio"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [cropperMinHeight]="cropperMinHeight"
      [cropperMinWidth]="cropperMinWidth"
      [imageQuality]="imageQuality"
      [imageURL]="imageURL"
      [maintainAspectRatio]="maintainAspectRatio"
      [resizeToHeight]="resizeToHeight"
      [resizeToWidth]="resizeToWidth"
      [transform]="transform"
      [zoomValue]="zoomValue"
      [minZoom]="minZoom"
      [maxZoom]="maxZoom"
      [showCropper]="showCropper"
      (imageCroppedEvent)="imageCropped($event)"
      (imageLoadedEvent)="imageLoaded()"
      (loadImageFailedEvent)="loadImageFailed()"
      (zoomChangedEvent)="transform = $event"
      (zoomValueChangedEvent)="zoomValue = $event"
      (roundCropperToggled)="isRoundCropper = $event"
      (cropClicked)="crop()"></app-image-cropper-dialog>
  </p-dialog>
</div>
